import React, { Component, Fragment } from 'react';
import { Row } from 'reactstrap';
import API from '../../../utils/API';

import moment from 'moment';
import { Col, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import InputField from '../../../components/inputs/inputField.js';
import TextAreaField from '../../../components/inputs/textAreaField';
import TimeField from '../../../components/inputs/timeField';
class EventAttendeeTravel extends Component {
	constructor(props) {
		super(props);
		this.toggle = this.toggle.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.state = {
			editing: false,
			editedAttendee: props.editedAttendee,
			genExpanded: true,
			popoverOpen: false,
			popoverOpen2: false
		};
	}

	toggleEditing = () => {
		this.setState({ editedAttendee: this.props.attendee, editing: true });
	};
	toggle = () => {
		this.setState({
			popoverOpen: !this.state.popoverOpen
		});
	}

	toggle2 = () => {
		this.setState({
			popoverOpen2: !this.state.popoverOpen2
		});
	}

	saveInfo = async () => {
		const { eventId, orgId } = this.props;
		const { editedAttendee } = this.state;
		await API()
			.patch(`Organizations/${orgId}/events/${eventId}/attendees/${editedAttendee._id}`, {
				...editedAttendee
			})
			.then((res) => {
				if (res.data) {
					this.props.updateAttendee(editedAttendee._id, res.data);
					this.setState({ editing: false, editedAttendee: res.data });
				}
			})
			.catch((e) => {
				this.setState({
					invalid: true,
					submitting: false
				});
			});
	};

	//'PATCH /Organizations/:organization/events/:event/attendees/:attendee'

	cancelEdit = () => {
		this.setState({ editedAttendee: this.props.attendee, editing: false });
	};
	componentDidUpdate(prevProps) {
		const { editedAttendee } = this.props;

		// Check if relevant dates have changed
		const datesChanged =
			prevProps.editedAttendee.travelInformation.arrivalDate !== editedAttendee.travelInformation.arrivalDate ||
			prevProps.editedAttendee.roomingInformation?.checkInDate !== editedAttendee.roomingInformation?.checkInDate ||
			prevProps.editedAttendee.roomingInformation?.arrivalDate !== editedAttendee.roomingInformation?.arrivalDate ||
			prevProps.editedAttendee.travelInformation.departureDate !== editedAttendee.travelInformation.departureDate ||
			prevProps.editedAttendee.roomingInformation?.checkOutDate !== editedAttendee.roomingInformation?.checkOutDate ||
			prevProps.editedAttendee.roomingInformation?.departureDate !== editedAttendee.roomingInformation?.departureDate;

		if (datesChanged) {
			// Recalculate travel mismatch for arrivals
			const flightAririval = editedAttendee.travelInformation.arrivalDate
				? moment(editedAttendee.travelInformation.arrivalDate).format('MM/DD/YYYY')
				: '';
			const hotelCheckin = editedAttendee.roomingInformation?.checkInDate
				? moment(editedAttendee.roomingInformation.checkInDate).format('MM/DD/YYYY')
				: '';
			const eventArrival = editedAttendee.roomingInformation?.arrivalDate
				? moment(editedAttendee.roomingInformation.arrivalDate).format('MM/DD/YYYY')
				: '';

			const isFlightValid = flightAririval && flightAririval !== 'Invalid date';
			const isEventValid = eventArrival && eventArrival !== 'Invalid date';
			const isHotelValid = hotelCheckin && hotelCheckin !== 'Invalid date';

			const flightHasConflict = isFlightValid && (
				(isHotelValid && flightAririval !== hotelCheckin) ||
				(isEventValid && flightAririval !== eventArrival)
			);

			// Recalculate travel mismatch for departures
			const flightDeparture = editedAttendee.travelInformation.departureDate
				? moment(editedAttendee.travelInformation.departureDate).format('MM/DD/YYYY')
				: '';
			const hotelCheckout = editedAttendee.roomingInformation?.checkOutDate
				? moment(editedAttendee.roomingInformation.checkOutDate).format('MM/DD/YYYY')
				: '';
			const eventDeparture = editedAttendee.roomingInformation?.departureDate
				? moment(editedAttendee.roomingInformation.departureDate).format('MM/DD/YYYY')
				: '';

			const isFlightDepartureValid = flightDeparture && flightDeparture !== 'Invalid date';
			const isEventDepartureValid = eventDeparture && eventDeparture !== 'Invalid date';
			const isHotelCheckoutValid = hotelCheckout && hotelCheckout !== 'Invalid date';

			const flightDepartureHasConflict = isFlightDepartureValid && (
				(isHotelCheckoutValid && flightDeparture !== hotelCheckout) ||
				(isEventDepartureValid && flightDeparture !== eventDeparture)
			);

			// Update travelMismatch if it has changed
			const overallMismatch = flightHasConflict || flightDepartureHasConflict;
			if (editedAttendee.travelMismatch !== overallMismatch) {
				this.props.editTravelFields({
					...this.props.editedAttendee,
					travelMismatch: overallMismatch
				});
			}
		}
	}

	render() {
		const { editing, genExpanded } = this.state;
		const { readOnly, editedAttendee } = this.props;
		const arrivalDate = editedAttendee.travelInformation.arrivalDate
			? moment(editedAttendee.travelInformation.arrivalDate).format('YYYY-MM-DD')
			: '';
		const arrivalTime = editedAttendee.travelInformation.arrivalTime;
		const departureDate = editedAttendee.travelInformation.departureDate
			? moment(editedAttendee.travelInformation.departureDate).format('YYYY-MM-DD')
			: '';
		const departureTime = editedAttendee.travelInformation.departureTime;

		//convert to MM/DD/YYYY and create variables for arrivals
		const flightAririval = editedAttendee.travelInformation.arrivalDate
			? moment(editedAttendee.travelInformation.arrivalDate).format('MM/DD/YYYY')
			: '';
		const hotelCheckin = editedAttendee.roomingInformation.checkInDate
			? moment(editedAttendee.roomingInformation.checkInDate).format('MM/DD/YYYY')
			: '';
		const eventArrival = editedAttendee.roomingInformation.arrivalDate
			? moment(editedAttendee.roomingInformation.arrivalDate).format('MM/DD/YYYY')
			: '';

		const isFlightValid = flightAririval && flightAririval !== 'Invalid date';
		const isEventValid = eventArrival && eventArrival !== 'Invalid date';
		const isHotelValid = hotelCheckin && hotelCheckin !== 'Invalid date';

		const arrivalHasConflict = isFlightValid && (
			(isHotelValid && flightAririval !== hotelCheckin) ||
			(isEventValid && flightAririval !== eventArrival)
		);

		// Display strings - only show flight arrival if it exists
		const FlightArrival = isFlightValid ? flightAririval + " - Flight Arrival" : "";
		const EventArrival = isEventValid ? eventArrival + " - Event Arrival" : "No Date Set - Event Arrival";
		const HotelCheckin = isHotelValid ? hotelCheckin + " - Hotel Check In" : "No Date Set - Hotel Check In";

		//convert to MM/DD/YYYY and create variables for departures
		const flightDeparture = editedAttendee.travelInformation.departureDate
			? moment(editedAttendee.travelInformation.departureDate).format('MM/DD/YYYY')
			: '';
		const hotelCheckout = editedAttendee.roomingInformation.checkOutDate
			? moment(editedAttendee.roomingInformation.checkOutDate).format('MM/DD/YYYY')
			: '';
		const eventDeparture = editedAttendee.roomingInformation.departureDate
			? moment(editedAttendee.roomingInformation.departureDate).format('MM/DD/YYYY')
			: '';

		const isFlightDepartureValid = flightDeparture && flightDeparture !== 'Invalid date';
		const isEventDepartureValid = eventDeparture && eventDeparture !== 'Invalid date';
		const isHotelCheckoutValid = hotelCheckout && hotelCheckout !== 'Invalid date';

		const departureHasConflict = isFlightDepartureValid && (
			(isHotelCheckoutValid && flightDeparture !== hotelCheckout) ||
			(isEventDepartureValid && flightDeparture !== eventDeparture)
		);

		// Display strings for departures
		const FlightDeparture = isFlightDepartureValid ? flightDeparture + " - Flight Departure" : "";
		const EventDeparture = isEventDepartureValid ? eventDeparture + " - Event Departure" : "No Date Set - Event Departure";
		const HotelCheckout = isHotelCheckoutValid ? hotelCheckout + " - Hotel Check Out" : "No Date Set - Hotel Check Out";

		const showArrivalWarnings = editedAttendee.travelMismatch && isFlightValid && arrivalHasConflict;
		const showDepartureWarnings = editedAttendee.travelMismatch && isFlightDepartureValid && departureHasConflict;

		// SIMPLIFIED - just check if we should show warnings
		let icon = showArrivalWarnings ? (
			<span className='c-pointer p-7' onMouseEnter={this.toggle} onMouseLeave={this.toggle}>
				<i id="Popover1" className="las la-lg la-exclamation-triangle red" />
			</span>
		) : false;

		let icon2 = showDepartureWarnings ? (
			<span className='c-pointer p-7' onMouseEnter={this.toggle2} onMouseLeave={this.toggle2}>
				<i id="Popover2" className="las la-lg la-exclamation-triangle red" />
			</span>
		) : false;

		return (
			<>
				<h2 className='blockHeader '>Arrival Information</h2>

				<div className='blocksContainer'>
					<div className='sectionBlock'>
						<div style={{ paddingTop: 5 }}>
							<InputField
								label={'Origin City'}
								value={editedAttendee.travelInformation.originCity}
								className="detailsInput"
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											originCity: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Origin State'}
								value={editedAttendee.travelInformation.originState}
								className="detailsInput"
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											originState: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Arrival City'}
								value={editedAttendee.travelInformation.arrivalCity}
								className="detailsInput"
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											arrivalCity: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Arrival State'}
								value={editedAttendee.travelInformation.arrivalState}
								className="detailsInput"
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											arrivalState: e.target.value
										}
									});
								}}
							/>

							{showArrivalWarnings && (
								<Popover placement="left" className="popoverWarrning" style={{ width: 229 }} isOpen={this.state.popoverOpen} target="Popover1" toggle={this.toggle}>
									<PopoverBody style={{ paddingBottom: 15 }}> Notice: Date mismatch </PopoverBody>
									<PopoverBody className="popoverWarrningBody">
										{isFlightValid && <div>{FlightArrival}</div>}
										{isEventValid && <div>{EventArrival}</div>}
										{isHotelValid && <div>{HotelCheckin}</div>}
									</PopoverBody>
								</Popover>
							)}
				<InputField
					label={'Arrival Date'}
					warningIcon={icon}
					className={`detailsInput`}
					timeFormat={false}
					type={'date'}
					inputIcon={<i className="lar la-calendar" />}
					onChange={(e) => {
						this.props.toggleEditing(true);
						this.props.editTravelFields({
							...this.props.editedAttendee,
							travelInformation: {
								...this.props.editedAttendee.travelInformation,
								arrivalDate: e.target.value
							}
						});
					}}
					value={arrivalDate}
				/>							{/* <InputField
								label={'Arrival Time'}
								value={arrivalTime}
								type={'time'}
								inputIcon={<i className="las la-clock" />}
								onChange={(e) => {
									console.log(e.target.value);

									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											arrivalTime: moment(
												` ${moment().format('MM/DD/YYYY')} ${e.target.value}`
											).format('hh:mm a')
										}
									});
								}}
							/> */}
							<TimeField
								label={'Arrival Time'}
								value={arrivalTime}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											arrivalTime: e
										}
									});
								}}
							/>

							<InputField
								label={'Arrival Carrier'}
								value={editedAttendee.travelInformation.arrivalCarrier}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											arrivalCarrier: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Arrival Flight'}
								value={editedAttendee.travelInformation.arrivalFlight}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											arrivalFlight: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Arrival Ticketed'}
								value={editedAttendee.travelInformation.arrivalTicketed}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											arrivalTicketed: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Arrival Class of Service'}
								value={editedAttendee.travelInformation.arrivalClassOfService}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											arrivalClassOfService: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Arrival Locator'}
								value={editedAttendee.travelInformation.arrivalLocator}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											arrivalLocator: e.target.value
										}
									});
								}}
							/>
							<div style={{ display: 'flex', flexDirection: 'row' }}>
								<div className="sectionSubtitle">Departure Information</div>
							</div>

							<InputField
								label={'Departure City'}
								value={editedAttendee.travelInformation.departureCity}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											departureCity: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Departure State'}
								value={editedAttendee.travelInformation.departureState}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											departureState: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Destination City'}
								value={editedAttendee.travelInformation.destinationCity}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											destinationCity: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Destination State'}
								value={editedAttendee.travelInformation.destinationState}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											destinationState: e.target.value
										}
									});
								}}
							/>

				{showDepartureWarnings && (
					<Popover placement="left" className="popoverWarrning" style={{ width: 229 }} isOpen={this.state.popoverOpen2} target="Popover2" toggle={this.toggle2}>
						<PopoverBody style={{ paddingBottom: 15 }}> Notice: Date mismatch </PopoverBody>
						<PopoverBody className="popoverWarrningBody">
							{isFlightDepartureValid && <div>{FlightDeparture}</div>}
							{isEventDepartureValid && <div>{EventDeparture}</div>}
							{isHotelCheckoutValid && <div>{HotelCheckout}</div>}
						</PopoverBody>
					</Popover>
				)}
				<InputField
					label={'Departure Date'}
					warningIcon={icon2}
					type={'date'}
					value={departureDate}
					inputIcon={<i className="lar la-calendar" />}
					onChange={(e) => {
						this.props.toggleEditing(true);
						this.props.editTravelFields({
							...this.props.editedAttendee,
							travelInformation: {
								...this.props.editedAttendee.travelInformation,
								departureDate: e.target.value
							}
						});
					}}
				/>							{/* 	<InputField
								label={'Departure Time'}
								value={departureTime}
								type={'time'}
								inputIcon={<i className="las la-clock" />}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											departureTime: moment(
												` ${moment().format('MM/DD/YYYY')} ${e.target.value}`
											).format('hh:mm a')
										}
									});
								}}
							/> */}
							<TimeField
								label={'Departure Time'}
								value={departureTime}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											departureTime: e
										}
									});
								}}
							/>



							<InputField
								label={'Departure Carrier'}
								value={editedAttendee.travelInformation.departureCarrier}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											departureCarrier: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Departure Flight'}
								value={editedAttendee.travelInformation.departureFlight}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											departureFlight: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Departure Ticketed'}
								value={editedAttendee.travelInformation.departureTicketed}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											departureTicketed: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Departure Class of Service'}
								value={editedAttendee.travelInformation.departureClassOfService}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											departureClassOfService: e.target.value
										}
									});
								}}
							/>

							<InputField
								label={'Departure Locator'}
								value={editedAttendee.travelInformation.departureLocator}
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											departureLocator: e.target.value
										}
									});
								}}
							/>
							<TextAreaField
								placeholder={''}
								value={editedAttendee.travelInformation.notes}
								label="Travel Notes"
								type="text"
								onChange={(e) => {
									this.props.toggleEditing(true);
									this.props.editTravelFields({
										...this.props.editedAttendee,
										travelInformation: {
											...this.props.editedAttendee.travelInformation,
											notes: e.target.value
										}
									});
								}}
							/>
						</div>
					</div>
				</div>
			</>
		);
	}
}

export default EventAttendeeTravel;
